import axios from 'axios'
// import notification from 'ant-design-vue/es/notification'
import { VueAxios } from './axios'
// import { ACCESS_TOKEN } from '@/store/mutation-types'
// import { i18nRender } from '@/locales'

// 创建 axios 实例
const request = axios.create({
  // API 请求的默认前缀
  // baseURL: '/api',
  baseURL: 'https://support.sigma-rt.com.cn',
  withCredentials: false,
  timeout: 60000 // 请求超时时间
})

// 异常拦截处理器
const errorHandler = (error) => {
  if (error.response) {
    // 判断返回的结果是否为一个对象
    if (Object.prototype.toString.call(error.response) === '[object Object]') {
      const start = error.response.config.headers['request-startTime']
      const currentTime = new Date().getTime()
      const requestDuration = (currentTime - start)// .toFixed(2)
      error.response.requestDuration = requestDuration
    }
    // 401服务器授权失败，则需要登录重试
    if (error.response.status === 401) {
      // notification.error({
      //   message: i18nRender('title.error'),
      //   description: i18nRender('result.fail.error.authorization')
      // })
      return Promise.reject(error)
    } else {
      // notification.error({
      //   message: i18nRender('title.error'),
      //   description: error.response.statusText
      // })
      // 从 localstorage 获取 token
      // const token = storage.get(ACCESS_TOKEN)
      // if (token) {
      //   store.dispatch('Logout').then(() => {
      //     setTimeout(() => {
      //       window.location.reload()
      //     }, 1500)
      //   })
      // }
    }
  } else {
    // notification.error({
    //   message: i18nRender('title.error'),
    //   description: error.toString()
    // })
  }
  return Promise.reject(error)
}

// request interceptor
request.interceptors.request.use(request => {
  request.headers['request-startTime'] = new Date().getTime()
  // const token = storage.get(ACCESS_TOKEN)
  // if (token) {
  //   // 过滤登录URL，让每个请求携带自定义的token
  //   if (request.url && request.url.lastIndexOf(global.API_LOGIN) === -1) {
  //     // if (request.method === 'get') {
  //     //   if (request.url.indexOf('token=') === -1) { // URL没有token，则自动添加
  //     //     request.params.token = token
  //     //   } else { // URL有token，则自动替换
  //     //     request.url = changeURLArg(request.url, 'token', token)
  //     //   }
  //     // } else {
  //     //   request.data.token = token
  //     // }
  //   }
  // }
  // console.log('interceptors.request token :>> ', token)
  // console.log('interceptors.request :>> ', request)
  // console.log('interceptors.request.url :>> ', request.url)
  // console.log('interceptors.request.data :>> ', request.data)
  // console.log('interceptors.request.headers :>> ', request.headers)
  // console.log('interceptors.request.params :>> ', request.params)
  // console.log('interceptors.request.method :>> ', request.method)
  return request
}, errorHandler)

// response interceptor
request.interceptors.response.use((response) => {
  // 判断返回的结果是否为一个对象
  // if (Object.prototype.toString.call(response) === '[object Object]') {
  //   const start = response.config.headers['request-startTime']
  //   const currentTime = new Date().getTime()
  //   const requestDuration = (currentTime - start)// .toFixed(2)
  //   response.requestDuration = requestDuration
  // }
  console.log('interceptors.response :>> ', response)
  return response
}, errorHandler)

const installer = {
  vm: {},
  install (Vue) {
    Vue.use(VueAxios, request)
  }
}

export default request

export {
  installer as VueAxios,
  request as axios
}
